import React from 'react';
import { classNames } from 'utils/functions';

export default function ShadowCard({
  wrapperClassName,
  className,
  contentClassName,
  title,
  children,
}: {
  wrapperClassName?: string;
  className?: string;
  contentClassName?: string;
  title?: string;
  children?: React.ReactNode;
}) {
  return (
    <div className={wrapperClassName}>
      <div
        className={classNames(
          className,
          '-mx-1 bg-white py-4 px-2 shadow-card md:mx-0 md:rounded-xl md:py-8 md:px-6'
        )}
      >
        {title && (
          <div className="border-b border-gray-400 pb-4 md:pb-6">
            <p className="text-primary-base font-bold">{title}</p>
          </div>
        )}
        <div className={classNames(contentClassName, 'mt-6')}>{children}</div>
      </div>
    </div>
  );
}
